// extracted by mini-css-extract-plugin
export default {"splitBtnGroup":"oAVd89LIToZ79v9nguiB"};